export default "__VITE_ASSET__DMj2Nf1u__"